import {appendPaginationQueryParamsToUrl} from '../utils'

export default host => (channelId, options) =>
  appendPaginationQueryParamsToUrl(`${host}/channels/${channelId}/purchases/export?export=all`, {...options, alreadyHasQueryParams: true})
